// Module
var code = "<template>\n\t<div ref=\"editorContainer\">\n\t\t\n\t</div>\n</template>\n";
// Exports
export default code;